import React, { useEffect, useState } from "react";
import moment from "moment";
// temporarily commented out due to functions using is WIP
import { API_URL } from "src/scenes/App";
import axios from "axios";
import styled from "styled-components";
import {
    UpperControls,
    ActivateFeatureButton,
    AspectRatioImageThumbnail,
    Button,
    DataTable,
    DataTableCell,
    DataTableContainer,
    DataTableEditActionButton,
    DataTableHeaderCheckboxContent,
    DataTableHeaderCell,
    DataTableLoading,
    DataTableViewActionButton,
    PortalPageShell,
    ConfirmModal,
    Toast,
    PortalSelect,
    PortalTableActions,
    PortalTableControls
} from "src/components";

//assets
import ArrowDown from "src/img/employeeList/SortUpArrow.svg";
import ArrowUp from "src/img/employeeList/SortDownArrow.svg";
import { TableRowCell } from "src/components/TableRowCell";

import Checkbox from "./Checkbox";
import { SurveyStatusType, SortableColumnState, SortablePollColumns } from "src/constants/survey";
import SurveyAndPollsHeading from "./SurveyAndPollsHeading";
import PollResultsModal from "./PollResultsModal";
import pluralize from "pluralize";
import { capitalizeString, customNames } from "src/utils/helpers";
import { PollVisibilityType } from "./Enums";

const SurveyButton = styled(Button).attrs(p => ({
    padding: p.padding || "10px 40px 10px",
    borderRadius: p.borderRadius || "8px !important",
    color: p.color || "#FFFFFF",
    cursor: p.cursor || "pointer"
}))`
    padding: 10px 40px 10px;
    border-radius: 8px !important;
    color: #FFFFFF;
    position: relative;
    cursor: pointer;
    margin: 0 1rem;

    @media (max-width: 768px) {
       margin: 0 0rem;
    }
`;

const ColumnHeader = (({ heading, sortDirection, styleProps }) => {
    const Container = styled.div`
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;

        text-align: center;
        user-select: none;
        cursor: pointer;
    `;

    const SortIndicator = styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;

        padding-left: 8px;
    `;

    return (
        <Container style={{ ...styleProps }}>
            {heading}
            <SortIndicator hidden={sortDirection === SortableColumnState.INACTIVE}>
                {(sortDirection === SortableColumnState.DESCENDING) &&
                    <img width="10px" src={ArrowDown} alt="SortArrow" />}
                {(sortDirection === SortableColumnState.ASCENDING) &&
                    <img width="10px" src={ArrowUp} alt="SortArrow" />}
            </SortIndicator>
        </Container>
    );
});

const InputSelector = styled(PortalSelect)``;

const FilterControl = styled.label`
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    color: var(--calendar-text, #171A22);
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.875rem;
    font-weight: 800;

    @media (max-width: 760px) {
        align-items: stretch;
        flex-direction: column;
        width: 100%;
    }
`;


const PollsTable = (props) => {
    const {
        sortColumn,
        pollsArray,
        showPollForm,
        fetchPoll,
        fetching,
        setSurveyStatusType,
        selectedSurveyOrPollStatusType,
        handleChangeTableType,
        selectedTableType,
        sortableColumns,
        showEditPollForm,
        user,
        setFetchingStatus,
        canManagePolls,
        featureContext,
        initialPollResultsUuid,
        onInitialPollResultsOpened
    } = props;
    const [selectedPolls, setSelectedPolls] = useState([]);
    const [selectAllPolls, setSelectAllPolls] = useState(false);
    const [showPollResults, setShowPollResults] = useState(false);
    const [viewPollUuid, setViewPollUuid] = useState("");

    useEffect(() => {
        if (!initialPollResultsUuid) return;
        showPollResultsModal(initialPollResultsUuid);
        onInitialPollResultsOpened?.();
    }, [initialPollResultsUuid]);

    /**
     * @param {number} length
     */

    const emitSortColumn = (string) => {
        string = string.replace(/ /g, "_").toUpperCase();
        return sortColumn(string);
    };

    const handleCheckbox = (e) => {
        const isChecked = e.target.checked;
        if (!isChecked) {
            setSelectedPolls([]);
        } else {
            let arr = [];
            pollsArray.map(survey => arr.push({
                uuid: survey.uuid,
                name: survey.name,
                surveyType: survey.surveyType,
                userGroup: survey.userGroup,
                startDate: survey.startDate,
                finishDate: survey.finishDate,
                status: survey.status
            }));
            setSelectedPolls(arr);
        }
        setSelectAllPolls(!selectAllPolls);
    };

    const handleChangeStatusFilter = (pollTypeStatus) => {
        setSurveyStatusType(pollTypeStatus);
        fetchPoll(pollTypeStatus);
    };

    const addRemovePollFromSelected = (event, survey) => {
        const isChecked = event.target.checked;

        const data = {
            uuid: survey.uuid,
            name: survey.name,
            surveyType: survey.surveyType,
            userGroup: survey.userGroup,
            startDate: survey.startDate,
            finishDate: survey.finishDate,
            status: survey.status
        };
        return isChecked ? setSelectedPolls([...selectedPolls, data])
            : setSelectedPolls(selectedPolls.filter((obj) => obj["uuid"] !== survey.uuid));
    };

    const checkIfUuidIsSelected = (uuid) => selectedPolls.some(obj => obj["uuid"] === uuid);

    const confirmDelete = (pollUuids) => {
        return ConfirmModal.open(
            "Permanently Remove Poll",
            <div>
                <p>Are you sure you want to remove this poll? All data from poll
                    insights for this poll will be lost</p><br></br>
                <hr/>
            </div>,
            () => { deletePolls(pollUuids); },
            "Remove",
            false
        );
    };

    const hidePollResultsModal = () => {
        setShowPollResults(false);
        setViewPollUuid("");
    };

    const showPollResultsModal = (selectedPollUuid) => {
        setViewPollUuid(selectedPollUuid);
        setShowPollResults(true);
    };

    const deletePolls = (pollUuids) => {
        ConfirmModal.close();
        setFetchingStatus(true);
        const pollUuidsArray = pollUuids.map(item => item.uuid);
        axios.delete(`${API_URL}/polls/deletePolls`, {
            data: { pollUuids: pollUuidsArray },
            headers: {
                Authorization: `Bearer ${user.token}`
            }
        }).then(res => {
            Toast.info("Selected Polls deleted successfully");
            fetchPoll(selectedSurveyOrPollStatusType);
        }).catch(error => {
            return Toast.error(error.getApiErrorDetails().message);
        }).finally(res => {
            setSelectedPolls([]);
            setSelectAllPolls(false);
        });
    };

    //generate empty lines when survey/client list is less than 10 records
    const emptyList = () => {
        const emptyRows = 10 - pollsArray.length;

        if (emptyRows < 1)
            return;

        return Array.from({ length: emptyRows }, (_, i) => (
            <tr key={"empty_" + i} className="placeholder-row">
                <DataTableCell $empty>&nbsp;</DataTableCell>
                <DataTableCell $empty>&nbsp;</DataTableCell>
                <DataTableCell $empty>&nbsp;</DataTableCell>
                <DataTableCell $empty>&nbsp;</DataTableCell>
                <DataTableCell $empty>&nbsp;</DataTableCell>
                <DataTableCell $empty>&nbsp;</DataTableCell>
                <DataTableCell $empty>&nbsp;</DataTableCell>
                <DataTableCell $empty>&nbsp;</DataTableCell>
                <DataTableCell $empty>&nbsp;</DataTableCell>
                <DataTableCell $empty>&nbsp;</DataTableCell>
            </tr>
        ));
    };

    const pollList = (pollItems) => pollItems.map(poll => {
        return (
            <tr key={poll.uuid}
                className={checkIfUuidIsSelected(poll.uuid) ? "selected" : ""}
            >
                <DataTableCell textAlign="center">
                    <label>
                        <Checkbox
                            readOnly
                            checked={checkIfUuidIsSelected(poll.uuid) || selectAllPolls}
                            value={poll.uuid}
                            onChange={(e) => addRemovePollFromSelected(e, poll)}
                        />
                    </label>
                </DataTableCell>
                <DataTableCell width={"7%"} textAlign="center" padding="0.35rem 0.6rem">
                    {!poll.image.isUsingCompanyLogo && (
                        <AspectRatioImageThumbnail
                            src={poll.image.imageUrl}
                            alt="Poll"
                            height="47px"
                            aspectRatio="83 / 47"
                            borderRadius="8px"
                            boxShadow="none"
                        />
                    )}
                </DataTableCell>
                <DataTableCell width={"18%"}>
                    <TableRowCell content={poll["question"]} clamp={1} padding="0"/>
                </DataTableCell>
                <DataTableCell textAlign="center">
                    {poll["numberOfOptions"]}
                </DataTableCell>

                <DataTableCell>
                    {
                        (() => {
                            const { allEmployees, allClients } = poll.pollVisibility;

                            const isAllEmployees = allEmployees === PollVisibilityType.EMPLOYEES;
                            const isAllClients = allClients === PollVisibilityType.CLIENTS;

                            let label = "";

                            if (isAllEmployees && !isAllClients) {
                                label = `All ${capitalizeString(pluralize(customNames.employees))}`;
                            } else if (!isAllEmployees && isAllClients) {
                                label = `All ${capitalizeString(pluralize(customNames.clients))}`;
                            } else if (isAllEmployees && isAllClients) {
                                label = `All ${capitalizeString(pluralize(customNames.employees))} & All ${capitalizeString(pluralize(customNames.clients))}`;
                            }

                            return <div>{label}</div>;
                        })()
                    }
                </DataTableCell>

                <DataTableCell>
                    {moment(poll["startDate"], "YYYY-MM-DD hh:mm:ss").format("D MMMM YYYY")}
                </DataTableCell>

                <DataTableCell>
                    {moment(poll["endDate"], "YYYY-MM-DD hh:mm:ss").format("D MMMM YYYY")}
                </DataTableCell>
                <DataTableCell textAlign="center" padding="0.35rem 0.6rem">
                    { selectedSurveyOrPollStatusType === SurveyStatusType.COMPLETE || !canManagePolls ?
                        "-"
                        :
                        <DataTableEditActionButton
                            onClick={() => showEditPollForm(poll.uuid) }
                            backgroundColor="var(--calendar-surface, #FFFFFF)"
                            color="var(--calendar-text, #171A22)"
                            border="1px solid var(--calendar-text, #171A22)"
                        >
                            Edit
                        </DataTableEditActionButton>
                    }
                </DataTableCell>
                <DataTableCell textAlign="center" padding="0.35rem 0.6rem">
                    {
                        (poll["showPollResults"] && poll["status"] !== "Scheduled") &&
                            <DataTableViewActionButton
                                onClick={() => showPollResultsModal(poll["uuid"]) }
                                backgroundColor="var(--calendar-action-primary-bg, #5B6EF5)"
                                color="var(--calendar-action-primary-text, #FFFFFF)"
                                border="1px solid var(--calendar-action-primary-bg, #5B6EF5)"
                            >
                                View
                            </DataTableViewActionButton>
                    }

                </DataTableCell>
                <DataTableCell textAlign="center">
                    {
                        poll["status"] === "Scheduled"
                            ?
                            <div style={{ fontWeight: "500", color: "var(--calendar-text, #171A22)" }}>{poll["status"]}</div>
                            :
                            <div style={{ fontWeight: "500", color: "#77B500" }}>{poll["status"]}</div>
                    }
                </DataTableCell>

            </tr>
        );
    });

    return (
        <PortalPageShell>
            <PollResultsModal
                showPollResults={showPollResults}
                onToggle={hidePollResultsModal}
                pollUuid={viewPollUuid}
            />
            <SurveyAndPollsHeading
                handleChangeTableType={handleChangeTableType}
                selectedTableType={selectedTableType}
                user={user}
                featureContext={featureContext}
            />
            <UpperControls >
                {/* hide for now as mentioned by John at Sept 09, 2024 */}
                {/* <SurveyButton marginLeft="2.5rem" backgroundColor="#000000" onClick={() => { showHowItWorks(true); }}>
                    <span>How Does It Work?</span>
                </SurveyButton> */}
                <PortalTableControls>
                    <FilterControl>
                        <span>Filter:</span>
                        <InputSelector width="12.5rem" value={selectedSurveyOrPollStatusType} onChange={(e) => handleChangeStatusFilter(e.target.value)} >
                            <option value={SurveyStatusType.ACTIVE} style={{ fontSize: "1rem" }}>
                                Active
                            </option>
                            <option value={SurveyStatusType.COMPLETE} style={{ fontSize: "1rem" }}>
                                Complete
                            </option>
                            <option value={SurveyStatusType.SCHEDULED} style={{ fontSize: "1rem" }}>
                                Scheduled
                            </option>
                        </InputSelector>
                    </FilterControl>
                    { canManagePolls && selectedPolls.length > 0 && <SurveyButton marginRight="0" style={{ fontWeight: "700" }} backgroundColor="#FF7171" onClick={(e) => confirmDelete(selectedPolls)}>
                        <span>Delete Selected Polls</span>
                    </SurveyButton>}
                </PortalTableControls>
                <PortalTableActions>
                    {canManagePolls && (
                        <ActivateFeatureButton width="170px" onClick={() => showPollForm(true)}>
                            <span>Create New Poll</span>
                        </ActivateFeatureButton>
                    )}
                </PortalTableActions>
            </UpperControls>

            { fetching &&
                <DataTableLoading minHeight="24rem" />
            }

            { !fetching &&
                <DataTableContainer maxWidth="98.625rem">
                    <DataTable minWidth="980px" rowHeight="5.25rem" cellPadding="0.45rem 0.85rem" headerPadding="0.7rem 0.85rem">
                        <thead>
                            <tr>
                                <DataTableHeaderCell width={"5%"}>
                                    {/* Select all, does not highlight all the selected rows for the time being */}
                                    <DataTableHeaderCheckboxContent>
                                        <label>
                                            <Checkbox readOnly checked={selectAllPolls} onChange={(e) => handleCheckbox(e)} key="0" />
                                        </label>
                                    </DataTableHeaderCheckboxContent>
                                </DataTableHeaderCell>
                                {/* column sorting does not show any icons at the moment, will add a fix to that later on */}
                                <DataTableHeaderCell width={"7%"} textAlign="center">
                                    <ColumnHeader heading="Image" />
                                </DataTableHeaderCell>
                                <DataTableHeaderCell width={"18%"} onClick={(e) => emitSortColumn("POLL_QUESTION")} >
                                    <ColumnHeader
                                        heading="Poll Question"
                                        sortDirection={sortableColumns[SortablePollColumns.POLL_QUESTION]}
                                        styleProps={{ justifyContent: "left" }}
                                    />
                                </DataTableHeaderCell>

                                <DataTableHeaderCell width={"10%"} onClick={() => emitSortColumn("NUMBER_OF_OPTIONS")} >
                                    <ColumnHeader
                                        heading="Number of Options"
                                        sortDirection={sortableColumns[SortablePollColumns.NUMBER_OF_OPTIONS]}
                                    />
                                </DataTableHeaderCell>

                                <DataTableHeaderCell width={"10%"} onClick={() => emitSortColumn("POLL_VISIBILITY")} >
                                    <ColumnHeader
                                        heading="Poll Visibility"
                                        sortDirection={sortableColumns[SortablePollColumns.POLL_VISIBILITY]}
                                    />
                                </DataTableHeaderCell>

                                <DataTableHeaderCell width={"10%"} onClick={() => emitSortColumn("START_DATE")} >
                                    <ColumnHeader
                                        heading="Start Date"
                                        sortDirection={sortableColumns[SortablePollColumns.START_DATE]}
                                        styleProps={{ justifyContent: "left" }}
                                    />
                                </DataTableHeaderCell>

                                <DataTableHeaderCell width={"10%"} onClick={() => emitSortColumn("FINISH_DATE")} >
                                    <ColumnHeader
                                        heading="Finish Date"
                                        sortDirection={sortableColumns[SortablePollColumns.FINISH_DATE]}
                                        styleProps={{ justifyContent: "left" }}
                                    />
                                </DataTableHeaderCell>

                                <DataTableHeaderCell width={"10%"} >
                                    <ColumnHeader
                                        heading="Edit"
                                    />
                                </DataTableHeaderCell>
                                <DataTableHeaderCell width={"10%"} >
                                    <ColumnHeader
                                        heading="Poll Results"
                                    />
                                </DataTableHeaderCell>
                                <DataTableHeaderCell width={"10%"} onClick={() => emitSortColumn("STATUS")} >
                                    <ColumnHeader
                                        heading="Status"
                                        sortDirection={sortableColumns[SortablePollColumns.STATUS]}
                                    />
                                </DataTableHeaderCell>
                            </tr>
                        </thead>

                        <tbody>
                            {pollList(pollsArray)}

                            {emptyList()}
                        </tbody>
                    </DataTable>
                </DataTableContainer>
            }
        </PortalPageShell>
    );
};


export default PollsTable;
